/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Digest_YesInputs */

const en_platform_digest_yes = /** @type {(inputs: Platform_Digest_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming`)
};

const pl_platform_digest_yes = /** @type {(inputs: Platform_Digest_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Będę`)
};

/**
* | output |
* | --- |
* | "Coming" |
*
* @param {Platform_Digest_YesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_digest_yes = /** @type {((inputs?: Platform_Digest_YesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Digest_YesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_digest_yes(inputs)
	return en_platform_digest_yes(inputs)
});